export default __webpack_public_path__ + "static/media/globe.811aebf9.svg";